import NavigationScroll from "./layout/NavigationScroll";
import { useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import AllRoutes from "./routes/AllRoutes";
import { AuthProvider } from "./context/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ToastContainer } from "react-toastify";
import Theme from "./themes/Theme";

function App() {
  const customization = useSelector((state) => state.customization);
  //console.log(customization);

  return (
    <StyledEngineProvider injectFirst>
       <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={Theme(customization)}>
        <AuthProvider>
          <CssBaseline />
          <NavigationScroll>
            <ToastContainer />
            <AllRoutes />
          </NavigationScroll>
        </AuthProvider>
      </ThemeProvider>
      </LocalizationProvider>
    </StyledEngineProvider>
  );
}

export default App;
